import "./feature-gallery.scss";

(function () {
	const sections = document.querySelectorAll(".feature-gallery[data-fg]");
	if (!sections.length) return;

	sections.forEach((root) => {
		const logosWrap = root.querySelector("[data-fg-logos]");
		if (!logosWrap) return;

		const visibleMax = Math.max(
			1,
			parseInt(root.getAttribute("data-visible-max") || "8", 10)
		);
		const doCycle = root.getAttribute("data-random-cycle") === "1";
		const cycleMs = Math.max(
			250,
			parseInt(root.getAttribute("data-cycle-ms") || "2000", 10)
		);
		const fadeDuration = 500;

		// Ensure exactly visibleMax slots are visible; rest become pool
		const allLogos = Array.from(logosWrap.querySelectorAll(".fg-logo"));
		allLogos.forEach((n, i) =>
			n.classList.toggle("is-hidden", i >= visibleMax)
		);

		// Track recent slots to avoid immediate repeats
		const recentIndices = [];
		const maxRecent = Math.min(Math.floor(visibleMax / 2), 3);
		let isAnimating = false;

		function getRandomVisibleIndex() {
			const available = [];
			for (let i = 0; i < visibleMax; i++) {
				if (!recentIndices.includes(i)) {
					available.push(i);
				}
			}

			const pool =
				available.length > 0
					? available
					: [...Array(visibleMax).keys()];
			const chosen = pool[Math.floor(Math.random() * pool.length)];

			recentIndices.push(chosen);
			if (recentIndices.length > maxRecent) {
				recentIndices.shift();
			}

			return chosen;
		}

		function doSwap() {
			if (isAnimating) return;

			const visibleLogos = Array.from(
				logosWrap.querySelectorAll(".fg-logo:not(.is-hidden)")
			);
			const hiddenLogos = Array.from(
				logosWrap.querySelectorAll(".fg-logo.is-hidden")
			);

			if (!visibleLogos.length || !hiddenLogos.length) return;

			const visibleIndex = getRandomVisibleIndex();
			const visibleSlot = visibleLogos[visibleIndex];
			const hiddenSlot =
				hiddenLogos[Math.floor(Math.random() * hiddenLogos.length)];

			if (!visibleSlot || !hiddenSlot) return;

			isAnimating = true;

			// Get position of visible slot
			const rect = visibleSlot.getBoundingClientRect();
			const parentRect = logosWrap.getBoundingClientRect();

			// Position hidden slot over visible slot
			hiddenSlot.classList.remove("is-hidden");
			Object.assign(hiddenSlot.style, {
				position: "absolute",
				top: rect.top - parentRect.top + "px",
				left: rect.left - parentRect.left + "px",
				width: rect.width + "px",
				height: rect.height + "px",
				opacity: "0",
				transition: `opacity ${fadeDuration}ms ease`,
				zIndex: "10",
			});

			// Force reflow
			hiddenSlot.offsetHeight;

			// Fade in
			hiddenSlot.style.opacity = "1";

			setTimeout(() => {
				// Swap DOM positions
				const visibleNext = visibleSlot.nextSibling;
				const hiddenNext = hiddenSlot.nextSibling;

				// Insert hidden where visible was
				if (visibleNext) {
					logosWrap.insertBefore(hiddenSlot, visibleNext);
				} else {
					logosWrap.appendChild(hiddenSlot);
				}

				// Insert visible where hidden was (at the end, hidden)
				if (hiddenNext && hiddenNext !== hiddenSlot) {
					logosWrap.insertBefore(visibleSlot, hiddenNext);
				} else {
					logosWrap.appendChild(visibleSlot);
				}

				// Reset styles on new visible
				hiddenSlot.style.cssText = "";

				// Hide the old one
				visibleSlot.classList.add("is-hidden");

				isAnimating = false;
			}, fadeDuration + 50);
		}

		if (!doCycle) return;

		// Ensure parent is positioned for absolute children
		if (getComputedStyle(logosWrap).position === "static") {
			logosWrap.style.position = "relative";
		}

		const startDelay = Math.floor(Math.random() * Math.min(1200, cycleMs));

		setTimeout(() => {
			setInterval(doSwap, cycleMs);
		}, startDelay);
	});
})();
